<template>
  <div :class="bannerWrapperClass">
    <div class="cursoonline-content">
      <div class="cursoonline-text">
        <span class="cursoonline-title">Curso online</span>
        <p>Realiza el curso inicial de Eurekers, en cualquier momento del día y desde cualquier lugar.</p>
        <p class="cursoonline-highlight">Gratuitas las dos primeras horas.</p>
      </div>
      <button @click="goToCourse" class="cursoonline-button mdc-button mdc-button--raised">
        <span v-if="type === 'header'" class="mdc-button__ripple"></span>
        <span class="mdc-button__label">Ver curso</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CursoOnlineBanner',
  props: {
    type: {
      type: String,
      default: 'header', // 'header' or 'sidebar'
      validator: function (value) {
        return ['header', 'sidebar'].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    bannerWrapperClass() {
      return this.type === 'header' ? 'course-cursoonline-header' : 'course-cursoonline-sidebar';
    }
  },
  methods: {
    goToCourse() {
      window.open('https://online.eurekers.com', '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
// Styles for 'header' type (from InformeDetail.vue)
.course-cursoonline-header {
  background: linear-gradient(135deg, var(--color-highlight) 0%, #0056b3 100%);
  border-radius: 16px;
  padding: 30px;
  margin-bottom: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -20px;
    right: -20px;
    width: 150px;
    height: 150px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -30px;
    left: -30px;
    width: 180px;
    height: 180px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    z-index: 0;
  }

  .cursoonline-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    position: relative;
    z-index: 1;

    @media (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  .cursoonline-text {
    color: white;

    .cursoonline-title {
      font-size: 24px;
      font-weight: 700;
      display: block;
      margin-bottom: 12px;
      color: white;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    p {
      margin: 6px 0;
      font-size: 16px;
      color: white;
      opacity: 0.95;
      max-width: 450px;
      line-height: 1.5;
    }

    .cursoonline-highlight {
      font-weight: 600;
      font-size: 18px;
      color: white;
      background-color: rgba(255, 255, 255, 0.25);
      padding: 8px 14px;
      border-radius: 8px;
      display: inline-block;
      margin-top: 8px;
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  .cursoonline-button {
    background-color: white;
    color: var(--color-highlight);
    border: none;
    border-radius: 10px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    white-space: nowrap;

    &:hover {
      background-color: white;
      transform: translateY(-3px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
    }
  }
}

// Styles for 'sidebar' type (from InformeMain.vue)
.course-cursoonline-sidebar {
  background: linear-gradient(135deg, var(--color-highlight) 0%, #0056b3 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -20px;
    right: -20px;
    width: 120px;
    height: 120px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -30px;
    left: -30px;
    width: 160px;
    height: 160px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
    z-index: 0;
  }

  .cursoonline-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
    position: relative;
    z-index: 1;
  }

  .cursoonline-text {
    color: white;

    .cursoonline-title {
      font-size: 22px;
      font-weight: 700;
      display: block;
      margin-bottom: 12px;
      color: white;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    p {
      margin: 6px 0;
      font-size: 15px;
      color: white;
      opacity: 0.95;
      line-height: 1.4;
    }

    .cursoonline-highlight {
      font-weight: 600;
      font-size: 16px;
      color: white;
      background-color: rgba(255, 255, 255, 0.25);
      padding: 6px 12px;
      border-radius: 6px;
      display: inline-block;
      margin-top: 8px;
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  .cursoonline-button {
    background-color: white;
    color: var(--color-highlight);
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 15px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    align-self: flex-start;
    margin-top: 6px;

    &:hover {
      background-color: white;
      transform: translateY(-3px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
    }
  }
}
</style> 